export default __webpack_public_path__ + "static/media/mpn-logotype-d.cabb04d3.svg";